import EDBox from '../../../../../../../BaseComponents/EDBox/EDBox';
import EDList from '../../../../../../../BaseComponents/List/EDList';
interface IProps {
  expanded: boolean;
}

const containerStyle = {
  paddingTop: 1,
  paddingBottom: 0,
  paddingLeft: 1,
  paddingRight: 0,
  display: 'flex',
  flexDirection: 'column',
};

export const BusinessCollectionMenuList: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  if (props.expanded) {
    return <EDList disableVerticalPadding>{props.children}</EDList>;
  }
  return <EDBox sx={containerStyle}>{props.children}</EDBox>;
};
